import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Grid , Icon , Card , Button } from 'semantic-ui-react';
import { amendCart } from '../../actions/quoteActions';
import macBook from '../../assets/pricing/macBook.png';
import motoG from '../../assets/pricing/motoG.png';

const styles = {
  mainWrapper : {
    paddingRight : '3.5%'
  },
  section : {
    marginTop : '20px'
  }
}

class SoftwareDisplay extends Component {
  constructor(props){
    super(props);
    this.state = {
      products : [
        { header : 'mobileAppLicense' , unitPrice : 50 , unit : 'month' , price : 600 , currency : 'HKD' , desc : 'mobileAppDesc' , image : motoG },
        { header : 'webAppAppLicense' , unitPrice : 100 , unit : 'month' , price : 1200 , currency : 'HKD' , desc : 'webAppDesc' , image : macBook }
      ]
    }
  }
  _renderProductSection(product){
    const { string , amendCart , locale } = this.props;
    const priceTag = (locale === 'zh') ? `${product.unitPrice} ${product.currency}` : `TBC`;
    return(
      <Card
        image={product.image}
        meta={`${string['price']} : ${priceTag} / ${string[product.unit]}`}
        key={product.header}
        header={string[product.header]}
        description={string[product.desc]}
        extra={
          <Grid>
            <Grid.Column className='ui two buttons computer only'>
              <Button basic color='green' onClick={()=>amendCart('add','software',product)}><Icon name="plus"/></Button>
              <Button basic color='red' onClick={()=>amendCart('minus','software',product)}><Icon name="minus"/></Button>
            </Grid.Column>
          </Grid>
        }
      />
    )
  }
  render(){
    const { products } = this.state;
    return (
      <Grid.Column style={styles.mainWrapper} width={12}>
        <Card.Group itemsPerRow={2} className="stackable">
        {products.map((product)=>this._renderProductSection(product))}
        </Card.Group>
      </Grid.Column>
    );
  }
}

function mapStateToProps(state) {
  return {
    locale : state.preference.locale,
    string : state.preference.string
  }
}

const mapDispatchToProps = (dispatch)=>bindActionCreators({ amendCart },dispatch)

export default connect(mapStateToProps,mapDispatchToProps)(SoftwareDisplay)



/** WEBPACK FOOTER **
 ** ./src/containers/price/softwareDisplay.js
 **/